/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelTransactionHistoryItem
 */
export interface FuelTransactionHistoryItem {
    /**
     * Transaction ID
     * @type {string}
     * @memberof FuelTransactionHistoryItem
     */
    id?: string;
    /**
     * USD amount spent (in cents)
     * @type {number}
     * @memberof FuelTransactionHistoryItem
     */
    fiatAmount?: number;
    /**
     * Formatted USD amount (e.g., "$12.50")
     * @type {string}
     * @memberof FuelTransactionHistoryItem
     */
    fiatAmountFormatted?: string;
    /**
     * Amount of Fuel received/used
     * @type {number}
     * @memberof FuelTransactionHistoryItem
     */
    fuelAmount?: number;
    /**
     * Transaction type (DEBIT = spent, CREDIT = received)
     * @type {string}
     * @memberof FuelTransactionHistoryItem
     */
    type?: FuelTransactionHistoryItemTypeEnum;
    /**
     * Transaction subject/source
     * @type {string}
     * @memberof FuelTransactionHistoryItem
     */
    subject?: string;
    /**
     * Human-readable description
     * @type {string}
     * @memberof FuelTransactionHistoryItem
     */
    description?: string;
    /**
     * Transaction timestamp
     * @type {Date}
     * @memberof FuelTransactionHistoryItem
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const FuelTransactionHistoryItemTypeEnum = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT'
} as const;
export type FuelTransactionHistoryItemTypeEnum = typeof FuelTransactionHistoryItemTypeEnum[keyof typeof FuelTransactionHistoryItemTypeEnum];


/**
 * Check if a given object implements the FuelTransactionHistoryItem interface.
 */
export function instanceOfFuelTransactionHistoryItem(value: object): value is FuelTransactionHistoryItem {
    return true;
}

export function FuelTransactionHistoryItemFromJSON(json: any): FuelTransactionHistoryItem {
    return FuelTransactionHistoryItemFromJSONTyped(json, false);
}

export function FuelTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fiatAmount': json['fiatAmount'] == null ? undefined : json['fiatAmount'],
        'fiatAmountFormatted': json['fiatAmountFormatted'] == null ? undefined : json['fiatAmountFormatted'],
        'fuelAmount': json['fuelAmount'] == null ? undefined : json['fuelAmount'],
        'type': json['type'] == null ? undefined : json['type'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function FuelTransactionHistoryItemToJSON(json: any): FuelTransactionHistoryItem {
    return FuelTransactionHistoryItemToJSONTyped(json, false);
}

export function FuelTransactionHistoryItemToJSONTyped(value?: FuelTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fiatAmount': value['fiatAmount'],
        'fiatAmountFormatted': value['fiatAmountFormatted'],
        'fuelAmount': value['fuelAmount'],
        'type': value['type'],
        'subject': value['subject'],
        'description': value['description'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

